module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am173-c72d95f61493f600fddf58de61f901d4.jpg";